<ng-container *ngIf="isAvailablePage$ | async">
  <ng-container
    *ngLet="{
      _mobile:
        settingsService.screenBreakpoint$ | async | appScreenLessThan: BreakpointTypeEnum.HalfSmall,
      _anonymous: (userState.user$ | async)?.anonymous,
      _isWizard: isWizardPage$ | async,
      _isProfile: isProfilePage$ | async,
      _isAvailable: isAvailablePage$ | async,
      _city: orderState.currentCity$ | async,
      _showChangeLocation: navPanelState.showChangeLocation$ | async
    } as obj"
  >
    <app-button
      *ngIf="obj._mobile && !obj._isWizard"
      type="secondary"
      class="--flex --align-center w-40-px h-40-px mrgn-lft--16 mrgn-top-6"
      (click)="openMobileSidebar()"
      aria-label="Открыть меню"
    >
      <app-svg type="none" src="/assets/img/burger-dark.svg"></app-svg>
    </app-button>

    <a routerLink="/">
      <app-svg type="none" [src]="themeState.logo$ | async"></app-svg>
    </a>

    <div class="--flex --align-center --gap-16 ml-auto">
      <a *ngIf="!obj._isWizard && obj._isAvailable" routerLink="/configurator/faq">
        <app-svg type="none" src="assets/img/question-notice-2.svg"></app-svg>
      </a>

      <h4
        *ngIf="obj._isWizard && obj._city && obj._showChangeLocation"
        class="subtitle-primary-medium-14 --crsr-pntr"
        (click)="changeLocation()"
      >
        {{ obj._city.title }}
      </h4>

      <a
        *ngIf="obj._isWizard && obj._anonymous"
        class="--flex --align-center --gap-4 app-text-color-addit app-text-link--not-underline"
        routerLink="/login"
      >
        <app-svg type="stroke" src="/assets/img/user-auth.svg"></app-svg>

        <span class="subtitle-primary-regular-14"> Войти </span>
      </a>
    </div>
  </ng-container>
</ng-container>
